import styled, { css } from 'styled-components';

export const SectionWrapper = styled.section`
	${({ theme }) => css`
		margin-bottom: 4rem;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			margin-bottom: 6.4rem;
		}
	`}
`;
